/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Recipe_Action_FavouriteInputs */

const en_recipe_action_favourite = /** @type {(inputs: Recipe_Action_FavouriteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Favourite`)
};

const de_recipe_action_favourite = /** @type {(inputs: Recipe_Action_FavouriteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Favorit`)
};

/**
* | output |
* | --- |
* | "Favourite" |
*
* @param {Recipe_Action_FavouriteInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const recipe_action_favourite = /** @type {((inputs?: Recipe_Action_FavouriteInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recipe_Action_FavouriteInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_recipe_action_favourite(inputs)
	return en_recipe_action_favourite(inputs)
});